import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Hidden from '@material-ui/core/Hidden';
import StickerIcon from '@material-ui/icons/CropFree';
import LogoutIcon from '@material-ui/icons/Lock';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PolicyIcon from '@material-ui/icons/Security';
import AccountIcon from '@material-ui/icons/AccountCircle';
import MapIcon from '@material-ui/icons/Map';
import {Auth} from 'aws-amplify';

import Main from './Main';
import {NavLink} from 'react-router-dom';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  }
});

class Navigation extends Component
{
  state = {
    mobileOpen: false,
  };

  handleDrawerToggle = () =>
  {
    this.setState(state => ({mobileOpen: !state.mobileOpen}));
  };

  handleCloseOnClick = () =>
  {
    this.setState(state => ({mobileOpen: false}));
  }

  componentWillMount()
  {
  }

  login()
  {
    //console.log("Login pressed");
  }

  logout()
  {
    Auth.signOut()
        .then(() =>
        {
          this.props.screenProps.onStateChange('signedOut', null);
        })
        .catch((error) =>
        {
          return error;
        })
  }

  render()
  {
    const {classes, theme} = this.props;

    const drawer = (
        <div>
          <div className={classes.toolbar}/>
          <Divider/>
          <List>
            <ListItem button component={NavLink} to="/stickers" onClick={this.handleCloseOnClick}>
              <ListItemIcon>
                <StickerIcon/>
              </ListItemIcon>
              <ListItemText primary="Sticker"/>
            </ListItem>
            <ListItem button component={NavLink} to="/map" onClick={this.handleCloseOnClick}>
              <ListItemIcon>
                <MapIcon/>
              </ListItemIcon>
              <ListItemText primary="Karte"/>
            </ListItem>
            <ListItem button component={NavLink} to="/profile" onClick={this.handleCloseOnClick}>
              <ListItemIcon>
                <AccountIcon/>
              </ListItemIcon>
              <ListItemText primary="Benutzerkonto"/>
            </ListItem>
          </List>
          <Divider/>
          <List>
            <ListItem button component={NavLink} to="/terms" onClick={this.handleCloseOnClick}>
              <ListItemIcon>
                <PolicyIcon/>
              </ListItemIcon>
              <ListItemText primary="AGB/Datenschutz"/>
            </ListItem>
          </List>
          <Divider/>
          <List>
            <ListItem button onClick={this.logout.bind(this)}>
              <ListItemIcon>
                <LogoutIcon/>
              </ListItemIcon>
              <ListItemText primary="Logout"/>
            </ListItem>
          </List>
          <Divider/>
          <Typography variant="body2" align="center" style={{paddingTop: '8px', color: 'rgba(0, 0, 0, 0.12)'}}>
            "QR Code" ist eine eingetragene Marke der DENSO WAVE INCORPORATED in Japan und anderen Ländern.
          </Typography>
          <Typography variant="body2" align="center" style={{paddingTop: '8px', color: 'rgba(0, 0, 0, 0.12)'}}>
            Version: {process.env.REACT_APP_VERSION}
          </Typography>
        </div>
    );

    return (
        <div className={classes.root}>
          <CssBaseline/>
          <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
              <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={this.handleDrawerToggle}
                  className={classes.menuButton}
              >
                <MenuIcon/>
              </IconButton>
              <Typography variant="h6" color="inherit" noWrap className={classes.grow}>
                <img src={require('../assets/img/logo-line-on-black.svg').default} height="20" alt="QRSticker logo"/>
              </Typography>
              <IconButton aria-label="Add" className={classes.margin} color="inherit" component={Link} to="/scanner">
                <PhotoCameraIcon/>
              </IconButton>
            </Toolbar>
          </AppBar>
          <nav className={classes.drawer}>
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Hidden smUp implementation="css">
              <Drawer
                  container={this.props.container}
                  variant="temporary"
                  anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                  open={this.state.mobileOpen}
                  onClose={this.handleDrawerToggle}
                  classes={{
                    paper: classes.drawerPaper,
                  }}
              >
                {drawer}
              </Drawer>
            </Hidden>
            <Hidden xsDown implementation="css">
              <Drawer
                  classes={{
                    paper: classes.drawerPaper,
                  }}
                  variant="permanent"
                  open
              >
                {drawer}
              </Drawer>
            </Hidden>
          </nav>
          <main className={classes.content}>
            <Main/>
          </main>
        </div>
    );
  }
}

Navigation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(Navigation);
